import * as React from 'react';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Field } from 'react-final-form';

import { MUIChangeEvent } from '../../../types';
import { useTheme } from '../../../theme';

interface Props {
	Seats: string[];
	Meal: string[];
}

const Preferences: React.FunctionComponent<Props> = props => {
	const css = useTheme('TravellerForm').Preferences,
		[seatSelect, setSeatSelect] = useState(props.Seats && props.Seats[0]),
		[mealSelect, setMealSelect] = useState(props.Meal && props.Meal[0]),
		{ t } = useTranslation('Traveller');

	return (
		<div className={css.preferences}>
			<h1 className={css.title}>{t('FLIGHT PREFERENCES')}</h1>
			<div className={css.selects}>
				<Field
					name={'preferences.seats'}
					defaultValue={seatSelect}
					render={({ input }) => (
						<FormControl>
							<InputLabel
								classes={{
									root: css.label,
									focused: css.focused
								}}
							>
								{t('Seats')}
							</InputLabel>

							<Select
								{...input}
								value={seatSelect}
								onChange={(event: MUIChangeEvent) => {
									if (typeof event.target.value === 'string') {
										setSeatSelect(event.target.value);
										input.onChange(event);
									}
								}}
							>
								{props.Seats &&
									props.Seats.map(seat => (
										<MenuItem key={seat} value={seat}>
											{seat}
										</MenuItem>
									))}
							</Select>
						</FormControl>
					)}
				/>
				<Field
					name={'preferences.meal'}
					defaultValue={mealSelect}
					render={({ input }) => (
						<FormControl>
							<InputLabel
								classes={{
									root: css.label,
									focused: css.focused
								}}
							>
								{t('Meal')}
							</InputLabel>

							<Select
								value={mealSelect}
								onChange={(event: MUIChangeEvent) => {
									if (typeof event.target.value === 'string') {
										setMealSelect(event.target.value);
										input.onChange(event);
									}
								}}
							>
								{props.Meal &&
									props.Meal.map(meal => (
										<MenuItem key={meal} value={meal}>
											{meal}
										</MenuItem>
									))}
							</Select>
						</FormControl>
					)}
				/>
			</div>
		</div>
	);
};

export default Preferences;
